import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';

// Components
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavLeftOldComponent } from './components/nav-left-old/nav-left-old.component';
import { NavLeftComponent } from './components/nav-left/nav-left.component';

// Error Pages
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { NotAuthorizedComponent } from './pages/errors/not-authorized/not-authorized.component';

// High Five Success Page
import { HighFiveSuccessComponent } from './pages/high-five-success/high-five-success.component';

// Pipes
import { KeysPipe } from './keys.pipe';
// Services
import { ProgramService } from './services/program.service';
import { AlertService } from './services/alert.service';
import { FeesService } from './fees.service';
import { FeeColumnFilterPanelService } from './services/fee-column-filter-panel.service';
import { EarlyBirdDiscountCodeService } from './services/early-bird-discount-code.service';
import { SiblingDiscountService } from './services/sibling-discount.service';
import { CodeDiscountService } from './services/code-discount.service';
import { MemberService } from './member.service';
import { PlayerAdjustmentService } from './services/player-adjustment.service';
import { FormsAndAgreementService } from './services/forms-and-agreement.service';
import { ClubDiscountService } from './services/club-discount.service';
import { MessageService } from './services/message.service';
import { FinancialsService } from './services/financials.service';
import { LeftNavigationService } from './services/left-navigation.service';
import { CheckBoxSelectionService } from '@syncfusion/ej2-angular-dropdowns';

// Shared dara services.
import { ScholarshipInfoService } from './shared-services/scholarship-info.service';
import { ClubMessagesService } from './shared-services/club-messages.service';
// import { ClubDiscountService } from './shared-services/club-discount.service';
import { FormDataService } from './shared-services/form-data.service';
import { FormCustomDataService } from './shared-services/form-custom-data.service';

// Shared dara services. (tryout)
import { InviteMemberDataService } from './shared-services/invite-member-data.service';

// UI Components
import { AgmCoreModule } from '@agm/core';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { NgxMaskModule } from 'ngx-mask'; // for add-credit, log-payment, make-quick-payment, fee-listing, tryout-fee-listing
import { NgCircleProgressModule } from 'ng-circle-progress';
import { Select2Module } from 'ng2-select2';
import { ConfirmWindowComponent } from './components/confirm-window/confirm-window.component';
import { PocDevSujeetComponent } from './pages/poc-dev-sujeet/poc-dev-sujeet.component';

import { QuestionServiceService } from './services/question-service.service';
import { DiscountScholarshipsComponent } from './components/discount-scholarships/discount-scholarships.component';
import { RemainingEarningsComponent } from './components/remaining-earnings/remaining-earnings.component';
import { TotalEarningsComponent } from './components/total-earnings/total-earnings.component';

import { AmountDeclinedComponent } from './components/amount-declined/amount-declined.component';
import { DeclinedMembersComponent } from './components/declined-members/declined-members.component';

// Coming Soon Page
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';

// TryOut Registration
import { TryoutBasicInfoComponent } from './tryout/pages/tryout-fee/tryout-basic-info/tryout-basic-info.component';
import { TryoutBillingInfoComponent } from './tryout/pages/tryout-fee/tryout-billing-info/tryout-billing-info.component';
import { TryoutFeeListingComponent } from './tryout/pages/tryout-fee/tryout-fee-listing/tryout-fee-listing.component';
import { TryoutPaymentInfoComponent } from './tryout/pages/tryout-fee/tryout-payment-info/tryout-payment-info.component';
import { TryoutReadQuestionsComponent } from './tryout/pages/tryout-questions/tryout-read-questions/tryout-read-questions.component';
import { TryoutAddCustomQuestionComponent } from './tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-add-custom-question/tryout-add-custom-question.component';
import { TryoutEditCustomQuestionComponent } from './tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-edit-custom-question/tryout-edit-custom-question.component';

// import { TryoutMessagesComponent } from './tryout/pages/tryout-messages/tryout-messages.component';
// import { TryoutPaymentReminderComponent } from './tryout/pages/tryout-messages/partial/tryout-payment-reminder/tryout-payment-reminder.component';
// import { TryoutRegistrationCompleteMessageComponent } from './tryout/pages/tryout-messages/partial/tryout-registration-complete-message/tryout-registration-complete-message.component';

import { TryoutFinancialsComponent } from './tryout/pages/tryout-financials/tryout-financials.component';
import { TryoutMembersComponent } from './tryout/pages/tryout-members/tryout-members.component';
import { TryoutInviteMembersComponent } from './tryout/pages/tryout-members/partial/tryout-invite-members/tryout-invite-members.component';
import { TryoutMemberInfoComponent } from './tryout/pages/tryout-members/partial/tryout-member-info/tryout-member-info.component';
import { TryoutSetQuestionsComponent } from './tryout/pages/tryout-members/partial/tryout-set-questions/tryout-set-questions.component';
import { TryoutProgramCreateComponent } from './tryout/pages/tryout-programs/tryout-program-create/tryout-program-create.component';
import { TryoutProgramReadComponent } from './tryout/pages/tryout-programs/tryout-program-read/tryout-program-read.component';
import { TryoutProgramUpdateComponent } from './tryout/pages/tryout-programs/tryout-program-update/tryout-program-update.component';

// TryOut Registration Component
import { TryoutActiveBillingProgramsComponent } from './tryout/components/tryout-active-billing-programs/tryout-active-billing-programs.component';
import { TryoutArchiveBillingProgramsComponent } from './tryout/components/tryout-archive-billing-programs/tryout-archive-billing-programs.component';
import { TryoutConfirmWindowComponent } from './tryout/components/tryout-confirm-window/tryout-confirm-window.component';
import { TryoutDiscountScholarshipsComponent } from './tryout/components/tryout-discount-scholarships/tryout-discount-scholarships.component';
import { TryoutFeeThisMonthIncomeComponent } from './tryout/components/tryout-fee-this-month-income/tryout-fee-this-month-income.component';
import { TryoutFeeTodayIncomeComponent } from './tryout/components/tryout-fee-today-income/tryout-fee-today-income.component';
import { TryoutFeeTotalIncomeComponent } from './tryout/components/tryout-fee-total-income/tryout-fee-total-income.component';
import { TryoutFullyPaidMembersComponent } from './tryout/components/tryout-fully-paid-members/tryout-fully-paid-members.component';
import { TryoutInactiveBillingProgramsComponent } from './tryout/components/tryout-inactive-billing-programs/tryout-inactive-billing-programs.component';
import { TryoutMessagesInUseComponent } from './tryout/components/tryout-messages-in-use/tryout-messages-in-use.component';
import { TryoutMessagesNotInUseComponent } from './tryout/components/tryout-messages-not-in-use/tryout-messages-not-in-use.component';
import { TryoutNotRequiredCustomQuestionsComponent } from './tryout/components/tryout-not-required-custom-questions/tryout-not-required-custom-questions.component';

import { TryoutPastDueComponent } from './tryout/components/tryout-past-due/tryout-past-due.component';
import { TryoutPastDueMembersComponent } from './tryout/components/tryout-past-due-members/tryout-past-due-members.component';
import { TryoutRegisteredMembersComponent } from './tryout/components/tryout-registered-members/tryout-registered-members.component';
import { TryoutRemainingEarningsComponent } from './tryout/components/tryout-remaining-earnings/tryout-remaining-earnings.component';
import { TryoutRequiredCustomQuestionsComponent } from './tryout/components/tryout-required-custom-questions/tryout-required-custom-questions.component';
import { TryoutRequiredFormsComponent } from './tryout/components/tryout-required-forms/tryout-required-forms.component';
import { TryoutTotalActiveDicountComponent } from './tryout/components/tryout-total-active-dicount/tryout-total-active-dicount.component';
import { TryoutTotalCustomQuestionsComponent } from './tryout/components/tryout-total-custom-questions/tryout-total-custom-questions.component';
import { TryoutTotalDiscountComponent } from './tryout/components/tryout-total-discount/tryout-total-discount.component';
import { TryoutTotalEarningsComponent } from './tryout/components/tryout-total-earnings/tryout-total-earnings.component';

import { TryoutTotalMessagesComponent } from './tryout/components/tryout-total-messages/tryout-total-messages.component';
import { InvitedMembersComponent } from './tryout/components/invited-members/invited-members.component';
import { NotInvitedMembersComponent } from './tryout/components/not-invited-members/not-invited-members.component';
import { TryoutTotalUsersUsingDiscountComponent } from './tryout/components/tryout-total-users-using-discount/tryout-total-users-using-discount.component';

import { TryoutAddStandardComponent } from './tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-add-standard/tryout-add-standard.component';
import { TryoutEditStandardComponent } from './tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-edit-standard/tryout-edit-standard.component';

// Club-Teams and Team-Players
import { ClubTeamsService } from './services/club-teams.service';

import { AuthService } from './services/auth.service';

// My Teams
import { MyTeamsService } from './services/my-teams.service';

// Tryout Services
import { TryoutProgramService } from './services/tryout_Services/tryout-program.service';
import { TryoutMemberService } from './services/tryout_Services/tryout-member.service';

// Components (New)
import { ProgramReadComponent } from './pages-new/program/program-read/program-read.component';
import { ProgramSaveComponent } from './pages-new/Program/program-save/program-save.component';
import { SharedModule } from './shared/shared.module';
import {
  ReportsService,
  HttpService,
  CommonService,
  StripeService,
  ClubMemberService,
  AssociationRegistrationService,
  HelperService,
  MainService,
  MyProfileDashboardService,
  PlayerDashboardService,
  PlayerService,
  StaffService,
  ClubService,
  WorkoutService,
  ClubEventsService,
  ClubComplexService,
  VideoService,
  InterceptorService,
  FileUploaderService,
} from './services';
import { AmChartsService } from '@amcharts/amcharts3-angular';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AppReducer } from './store/app.reducer';
import { AppEffects } from './store/app.effects';
import { AuthGuard } from './guards/auth.guard';
import { TeamGuard } from './guards/team.guard';
import { TokenService } from './services/token.service';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { DisputesService } from './services/disputes.service';
import { TryoutAssignTeamComponent } from './tryout/pages/tryout-assign-team/tryout-assign-team.component';
import { UserProgramRoleGuard } from './guards/user-program-role.guard';
import { EvaluationsService } from './services/evaluations.service';
import { ClubEvaluationDetailsComponent } from './pages/club-evaluations/evaluation-details/evaluation-details.component';
import { ClubEvaluationPlayersComponent } from './pages/club-evaluations/players/club-evaluation-players.component';
import { ClubEvaluationStaffComponent } from './pages/club-evaluations/staff/club-evaluation-staff.component';
import { ClubProgramService } from './services/club-program.service';
import { PlayerEvaluationResultComponent } from './pages/player/evaluation-result/evaluation-result.component';
import { PlayerEvaluationCheckComponent } from './pages/player/evaluation-check/evaluation-check.component';
import { PlayerEvaluationCompleteComponent } from './pages/player/evaluation-complete/evaluation-complete.component';
import { SendGridService } from './services/sendgrid.service';
import { PlayerDiscountService } from './services/player-discount.service';
import { CollegeRecrutingCenterService } from './services/college-recruiting-center.service';
import { environment, ProgramsBillingType } from './store';
import { ImageCropperModule } from 'ngx-image-cropper';
import { InjuryService } from './services/injury.service ';
import { AuthUiService } from './shared-services/auth-ui.service';
import { ClubInjuriesModule } from './pages/club-injuries/club-injuries.module';

import { TeamInjuriesModule } from './pages/team-injuries/team-injuries.module';
import { DevelopmentCalendarService } from './services/development-calendar.service ';
import { TeamDevelopmentCalendarModule } from './pages/team-development-calendar/team-development-calendar.module';
import { ClubEvaluationDashboardComponent } from './pages/club-evaluations/evaluation-dashboard/evaluation-dashboard.component';
import { ClubSchedulerService } from './services/club-scheduler.service.ts';
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { CampaignService } from './services/campaign.service';

/* Firebase Configuration */
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { MembersComponent } from './pages/members/members.component';
import { OurSystemStatusComponent } from './shared/components/our-system-status/our-system-status.component';
import { SystemUpdateComponent } from './shared/components/system-update/system-update.component';
import { AuthFirebaseGuard } from './guards/auth.firebase';
import { SafeSportService } from './services/safesport.service';
import { TeamHealthProgramsComponent } from './pages/team-health-programs/team-health-programs.component';
import { AssociationRegistrationAthleteoneComponent } from './pages/association-registration-athleteone/association-registration-athleteone.component';

@NgModule({
  declarations: [
    AppComponent,
    ClubEvaluationDashboardComponent,
    ClubEvaluationDetailsComponent,
    ClubEvaluationPlayersComponent,
    ClubEvaluationStaffComponent,
    HeaderComponent,
    FooterComponent,
    NavLeftOldComponent,
    NavLeftComponent,
    KeysPipe,
    NotFoundComponent,
    NotAuthorizedComponent,
    HighFiveSuccessComponent,
    ConfirmWindowComponent,
    PocDevSujeetComponent,
    PlayerEvaluationResultComponent,
    PlayerEvaluationCheckComponent,
    PlayerEvaluationCompleteComponent,
    TryoutTotalUsersUsingDiscountComponent,
    DiscountScholarshipsComponent,
    RemainingEarningsComponent,
    TotalEarningsComponent,
    TryoutBasicInfoComponent,
    TryoutBillingInfoComponent,
    TryoutFeeListingComponent,
    TryoutPaymentInfoComponent,
    TryoutReadQuestionsComponent,
    TryoutAddCustomQuestionComponent,
    TryoutEditCustomQuestionComponent,
    TryoutFinancialsComponent,
    TryoutMembersComponent,
    TryoutProgramCreateComponent,
    TryoutProgramReadComponent,
    TryoutProgramUpdateComponent,
    TryoutActiveBillingProgramsComponent,
    TryoutArchiveBillingProgramsComponent,
    TryoutConfirmWindowComponent,
    TryoutDiscountScholarshipsComponent,
    TryoutFeeThisMonthIncomeComponent,
    TryoutFeeTodayIncomeComponent,
    TryoutFeeTotalIncomeComponent,
    TryoutFullyPaidMembersComponent,
    TryoutInactiveBillingProgramsComponent,
    TryoutMessagesInUseComponent,
    TryoutMessagesNotInUseComponent,
    TryoutNotRequiredCustomQuestionsComponent,
    TryoutPastDueComponent,
    TryoutPastDueMembersComponent,
    TryoutRegisteredMembersComponent,
    TryoutRemainingEarningsComponent,
    TryoutRequiredCustomQuestionsComponent,
    TryoutRequiredFormsComponent,
    TryoutTotalActiveDicountComponent,
    TryoutTotalCustomQuestionsComponent,
    TryoutTotalDiscountComponent,
    TryoutTotalEarningsComponent,
    TryoutTotalMessagesComponent,
    TryoutSetQuestionsComponent,
    TryoutMemberInfoComponent,
    TryoutInviteMembersComponent,
    InvitedMembersComponent,
    NotInvitedMembersComponent,
    TryoutAddStandardComponent,
    TryoutEditStandardComponent,
    DeclinedMembersComponent,
    ComingSoonComponent,
    AmountDeclinedComponent,
    ProgramReadComponent,
    ProgramSaveComponent,
    RedirectComponent,
    TeamHealthProgramsComponent,
    TryoutAssignTeamComponent,
    MembersComponent,
    AssociationRegistrationAthleteoneComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    SharedModule,
    ImageCropperModule,
    TimePickerModule,
    StoreModule.forRoot({ app: AppReducer }),
    EffectsModule.forRoot([AppEffects]),

    SimpleNotificationsModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAhYXH8ZM6Y3ZkSWvvnqxzIPicYJBdVVXc',
      libraries: ['places']
    }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    // Specify ng-circle-progress as an import
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#4b80e0',
      innerStrokeColor: '#4b80e0',
      animationDuration: 300,
    }),
    Select2Module,
    ClubInjuriesModule,
    TeamInjuriesModule,
    TeamDevelopmentCalendarModule,

    // AngularFireModule.initializeApp(environment.firebaseConfig),
    // AngularFireDatabaseModule,
    // FirebaseModule,
    RouterModule.forRoot([
      {
        path: 'stripe',
        loadChildren: './pages/stripe/stripe.module#StripeModule'
      },
      {
        path: 'club-staff',
        loadChildren: './pages/club-staffs/club-staffs-routing.module#ClubStaffsRoutingModule',
        canActivate: [AuthGuard]
      },
      { path: 'redirect', component: RedirectComponent },
      // Tryout
      { path: 'tryoutprogram/:status', component: TryoutProgramReadComponent, canActivate: [AuthGuard] },
      {
        path: 'tryoutprogram/tryout/add',
        component: TryoutProgramCreateComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/tryout-program/:id',
        component: TryoutProgramUpdateComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/:name/:id/assignment',
        loadChildren: './pages/billing/assignment/assignment.module#AssignmentModule',
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/:name/:id/:status/fee/step1',
        component: TryoutBasicInfoComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/:name/:id/:status/fee/step1/:feeId',
        component: TryoutBasicInfoComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/:name/:id/:status/fee/step2/:feeId',
        component: TryoutBillingInfoComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/:name/:id/:status/fee/step3/:feeId',
        component: TryoutPaymentInfoComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/:name/:id/:status/fee',
        component: TryoutFeeListingComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutmembers/:name/:id/:status',
        component: TryoutMembersComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'camps-clinics-billing/waiting-list/:name/:id/:status',
        component: TryoutMembersComponent,
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutprogram/:name/:id/:status/question/:isRequired',
        component: TryoutReadQuestionsComponent,
        canActivate: [UserProgramRoleGuard]
      },
      // { path: 'tryoutprogram/:name/:id/:status/formagreement/:isRequired', component: ReadTryoutFormsAndAgreementComponent },
      {
        path:
          'tryoutprogram/:name/:id/:status/:programTypeId/formagreement/:isRequired',
        loadChildren:
          './pages/billing/billing-forms/billing-forms.module#BillingFormsModule',
        canActivate: [UserProgramRoleGuard]
      },
      {
        path: 'tryoutmessage/:name/:id/:programTypeId',
        loadChildren: './pages/billing/messages/messages.module#MessagesModule',
        canActivate: [UserProgramRoleGuard]
      },

      {
        path: 'tryoutfinancial/:name/:clubProgramId',
        // component: TryoutFinancialsComponent,
        // canActivate: [UserProgramRoleGuard]
        loadChildren: './pages/billing/billing-financials/billing-financials.module#BillingFinancialsModule',
        canActivate: [UserProgramRoleGuard],
        data: {
          billingTypeID: ProgramsBillingType.TryoutBilling
        }
      },
      {
        path: 'tryoutreport/:name/:id',
        component: TryoutFinancialsComponent,
        canActivate: [UserProgramRoleGuard]
      },
      { path: '404', component: NotFoundComponent },
      { path: '401', component: NotAuthorizedComponent },
      { path: 'high-five-success/:successTab', component: HighFiveSuccessComponent, canActivate: [AuthGuard] },


      // { path: '', redirectTo: '/skj', pathMatch: 'full' },
      // { path: 'skj', component: PocDevSujeetComponent },
      { path: 'club', loadChildren: './pages/club/club.module#ClubModule', canActivate: [AuthGuard] },
      { path: 'club-scheduler', loadChildren: './pages/club-scheduler/club-scheduler.module#ClubSchedulerModule', canActivate: [AuthGuard] },

      // Hotel
      { path: 'hotel', loadChildren: './pages/hotel/hotel.module#HotelModule', canActivate: [AuthGuard] },

      // All Players for Club
      {
        path: 'club-players',
        loadChildren:
          './pages/club-players/club-players.module#ClubPlayersModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'club-complex',
        loadChildren:
          './pages/club-complex/club-complex.module#ClubComplexModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'club-evaluation/templates',
        loadChildren:
          './pages/club-evaluations/club-evaluations.module#ClubEvaluationsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'college-recruiting',
        loadChildren:
          './pages/college-recruiting/college-recruiting.module#CollegeRecruitingModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'communication-center',
        loadChildren:
          './pages/sendgrid/communication-center.module#CommunicationCenterModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'communication-center-team',
        loadChildren:
          './pages/sendgrid/mobile-app-dashboard-data/mobile-app-dashboard.module#MobileAppDashboardModule',
        canLoad: [AuthFirebaseGuard],
      },
      {
        path: 'video-center',
        loadChildren: './pages/video-center/video-center.module#VideoCenterModule',
        canActivate: [AuthGuard]
      },

      {
        path: 'products',
        loadChildren: './pages/products/products.module#ProductsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'club-evaluation/details/:id',
        component: ClubEvaluationDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'club-evaluation/dashboard',
        component: ClubEvaluationDashboardComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'club-evaluation/players',
        component: ClubEvaluationPlayersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'player',
        loadChildren: './pages/player/player.module#PlayerModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'club-evaluation/staff',
        component: ClubEvaluationStaffComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'player-info/:playerID/evaluation-result/:userEvaluationID',
        component: PlayerEvaluationResultComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'staff/:staffID/evaluation-check',
        component: PlayerEvaluationCheckComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'details/:playerID/player-evaluation-complete/:userEvaluationID/:status',
        component: PlayerEvaluationCompleteComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'staff/all/evaluations',
        component: PlayerEvaluationCheckComponent,
        canActivate: [AuthGuard]
      },
      // Coming Soon
      {
        path: 'coming-soon',
        component: ComingSoonComponent
      },
      // Club Events
      {
        path: 'events',
        loadChildren: './pages/club-events/club-events.module#ClubEventsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'financials',
        loadChildren: './pages/club-financials/club-financials.module#ClubFinancialsModule',
        canActivate: [AuthGuard]
      },
      // My Teams
      {
        path: 'auth',
        loadChildren: './pages/auth/auth.module#AuthModule',
      },
      // My Teams
      {
        path: 'team-admin',
        loadChildren: './pages/team-admin/team-admin.module#TeamAdminModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'team-health-programs',
        component: TeamHealthProgramsComponent,
        canActivate: [AuthGuard]
      },
      // Team Billing
      {
        path: 'team-billing',
        loadChildren: './pages/billing/billing.module#BillingModule',
        canActivate: [AuthGuard],
        data: {
          billingTypeID: ProgramsBillingType.TeamBilling
        }
      },
      // Travel Billing
      {
        path: 'travel-billing',
        loadChildren: './pages/billing/billing.module#BillingModule',
        canActivate: [AuthGuard],
        data: {
          billingTypeID: ProgramsBillingType.TravelBilling
        }
      },
      // Recreational Billing
      {
        path: 'recreational-billing',
        loadChildren: './pages/billing/billing.module#BillingModule',
        canActivate: [AuthGuard],
        data: {
          billingTypeID: ProgramsBillingType.RecreationalBilling
        }
      },
      // Recreational Billing
      {
        path: 'camps-clinics-billing',
        loadChildren: './pages/billing/billing.module#BillingModule',
        canActivate: [AuthGuard],
        data: {
          billingTypeID: ProgramsBillingType.CampsClinics
        }
      },
      // Association Registration
      { path: 'safesport', component: AssociationRegistrationAthleteoneComponent },

      // Association Registration
      { path: 'association', component: AssociationRegistrationAthleteoneComponent },
      // {
      //   path: 'association',
      //   loadChildren:
      //     './pages/association-registration/association-registration.module#AssociationRegistrationModule',
      //   canActivate: [AuthGuard]
      // },
      {
        path: 'workouts',
        loadChildren: './pages/workouts/workouts.module#WorkoutsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'team-injury',
        loadChildren: './pages/team-injuries/team-injuries.module#TeamInjuriesModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'team-development-calendar',
        loadChildren: './pages/team-development-calendar/team-development-calendar.module#TeamDevelopmentCalendarModule',
        canActivate: [AuthGuard]
      },
      // Club Billing
      {
        path: 'club-injury',
        loadChildren: './pages/club-injuries/club-injuries.module#ClubInjuriesModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'development-calendar',
        loadChildren: './pages/development-chart/development-chart.module#DevelopmentChartModule',
        canActivate: [AuthGuard]
      },
      {
        path: '',
        loadChildren: './pages/billing/billing.module#BillingModule',
        canActivate: [AuthGuard],
        data: {
          billingTypeID: ProgramsBillingType.ClubBilling
        }
      },
      {
        path: 'club-list',
        loadChildren:
          './pages/club-list/club-list.module#ClubListModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'demo-test',
        loadChildren:
          './pages/demo-test/demo-test.module#DemoTestModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'tgs-backend-members',
        component: MembersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'account',
        loadChildren:
          './pages/account/account.module#AccountModule',
        canActivate: [AuthGuard]
      },
      { path: 'club/dashboard/our-system-status', component: OurSystemStatusComponent, canActivate: [AuthGuard] },
      { path: 'club/dashboard/our-system-updates', component: SystemUpdateComponent, canActivate: [AuthGuard] },
      //{ path: 'safesport', loadChildren: './pages/safesport-training/safesport-training.module#SafeSportTrainingModule', canActivate: [AuthGuard] },
      { path: 'staff-safesport', loadChildren: './pages/safesport-training/safesport-training.module#SafeSportTrainingModule', canActivate: [AuthGuard] },

      { path: '**', redirectTo: '/404' }
    ])
  ],
  providers: [
    ProgramService,
    AlertService,
    TokenService,
    FeesService,
    FeeColumnFilterPanelService,
    EarlyBirdDiscountCodeService,
    SiblingDiscountService,
    CodeDiscountService,
    MemberService,
    PlayerAdjustmentService,
    QuestionServiceService,
    FormsAndAgreementService,
    ClubDiscountService,
    MessageService,
    FinancialsService,
    LeftNavigationService,
    ScholarshipInfoService,
    ClubMessagesService,
    ClubMemberService,
    TryoutProgramService,
    TryoutMemberService,
    InviteMemberDataService,
    FormDataService,
    AuthUiService,
    FormCustomDataService,
    ReportsService,
    DisputesService,
    EvaluationsService,
    SendGridService,
    CampaignService,
    CollegeRecrutingCenterService,
    PlayerDiscountService,
    CommonService,
    HttpService,
    StripeService,
    AmChartsService,
    AssociationRegistrationService,
    ClubTeamsService,
    AuthService,
    MyTeamsService,
    CheckBoxSelectionService,
    ClubProgramService,
    HelperService,
    MainService,
    MyProfileDashboardService,
    PlayerDashboardService,
    PlayerService,
    StaffService,
    ClubService,
    WorkoutService,
    InjuryService,
    DevelopmentCalendarService,
    ClubEventsService,
    ClubComplexService,
    ClubSchedulerService,
    VideoService,
    InterceptorService,
    FileUploaderService,
    SafeSportService,
    AuthGuard,
    TeamGuard,
    UserProgramRoleGuard,
    AuthFirebaseGuard,

    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: InterceptorService
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts